module.exports = __webpack_public_path__ + "static/media/Rhyme-Detector-screenshot.fc4db37b.png";